import React, {JSX} from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';
type TitleVariants = 'h1' | 'h2';

const Title: React.FC<{variant: TitleVariants; children: React.ReactNode; nativeClassNames?: string}> = ({
  variant,
  children,
  nativeClassNames
}) => {
  const Tag = variant as keyof JSX.IntrinsicElements;

  return <Tag className={classNames(styles.title, styles[variant], nativeClassNames)}>{children}</Tag>;
};

export default Title;
